import React from "react";
import { useScreenDetector } from "@/utils/dom";
import styles from "./style.less";

const Box = ({ children, width }) => {
  const { isDesktop } = useScreenDetector(768, 1600);

  return (
    <div
      className={styles.box}
      style={{
        width: isDesktop ? width || "30%" : "80%",
        maxWidth: "800px",
      }}
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          flexGrow: 1,
          flexDirection: "column",
          width: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Box;
